const SYNODIC = 29.530588853;
const REF_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14);
const NAMES = ["New Moon", "Waxing Crescent", "First Quarter", "Waxing Gibbous", "Full Moon", "Waning Gibbous", "Last Quarter", "Waning Crescent"];

export const getMoonPhase = (date = new Date()) => {
  const days = (date.getTime() - REF_NEW_MOON) / 86400000;
  const f = (((days % SYNODIC) + SYNODIC) % SYNODIC) / SYNODIC;
  return {
    fraction: f,
    illumination: Math.round(((1 - Math.cos(2 * Math.PI * f)) / 2) * 100),
    name: NAMES[Math.round(f * 8) % 8],
  };
};

const litPath = (f, c = 12, R = 10) => {
  const rx = Math.abs(Math.cos(2 * Math.PI * f)) * R;
  const waxing = f < 0.5;
  const gibbous = f > 0.25 && f < 0.75;
  const outer = `M${c} ${c - R} A${R} ${R} 0 0 ${waxing ? 1 : 0} ${c} ${c + R}`;
  const sweep = waxing ? (gibbous ? 1 : 0) : (gibbous ? 0 : 1);
  return `${outer} A${rx} ${R} 0 0 ${sweep} ${c} ${c - R} Z`;
};

export const MoonPhase = () => {
  const { fraction, illumination, name } = getMoonPhase();
  return (
    <div data-testid="moon-phase" className="mt-10 inline-flex items-center gap-3 sm:gap-4 rounded-full border border-[#B59A5B]/30 bg-[#121A23]/60 backdrop-blur px-4 sm:px-5 py-2.5">
      <svg viewBox="0 0 24 24" className="w-6 h-6 shrink-0" aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="#1E2834" stroke="#B59A5B" strokeOpacity="0.5" strokeWidth="0.6" />
        <path d={litPath(fraction)} fill="#D8BE7F" />
      </svg>
      <span className="hidden sm:block h-px w-8 bg-[#B59A5B]/60" />
      <p className="text-left font-caps text-[11px] sm:text-xs tracking-[0.2em] uppercase text-[#E2CC92]">
        Tonight · <span data-testid="moon-phase-name">{name}</span>
        <span className="block sm:inline text-[#FAF6ED]/70 normal-case tracking-normal font-body"><span className="hidden sm:inline"> — </span><span data-testid="moon-phase-illumination">{illumination}%</span> illuminated</span>
      </p>
    </div>
  );
};
